import React from 'react';
import { useNewSessionModal } from '../context/NewSessionModalContext';
import SessionForm from './SessionForm';

// Dialog chrome for the standalone "New Session" flow — backdrop + white card
// + X close, modeled on OfferingFormModal.js's overlay/modal styles (not
// SessionForm's own 440px modal, which is sized for the small create-client
// dialog and too narrow for the full form). SessionForm itself supplies all
// the content via its existing `embedded`/`onCancel`/`onSaved` props — no new
// props were added to SessionForm for this.
export default function NewSessionModal() {
  const { isOpen, prefill, closeNewSession } = useNewSessionModal();

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={closeNewSession}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={styles.title}>New session</div>
          <button style={styles.close} onClick={closeNewSession}>×</button>
        </div>
        <SessionForm
          embedded
          onCancel={closeNewSession}
          onSaved={closeNewSession}
          initialClientIds={prefill?.clientIds || []}
        />
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(26,46,40,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, backdropFilter: 'blur(2px)', padding: '20px' },
  modal: { background: 'white', borderRadius: '16px', width: '720px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: 'var(--shadow-lg)', padding: '28px' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' },
  title: { fontFamily: "'Lora', Georgia, serif", fontSize: '24px', fontWeight: '400', color: 'var(--text-dark)' },
  close: { background: 'none', border: 'none', fontSize: '24px', color: 'var(--text-faint)', cursor: 'pointer', lineHeight: 1 },
};
